import type { AppRouteModule } from '/@/router/types';
import { LAYOUT2 } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';

const market: AppRouteModule = {
  path: '/market',
  name: 'Market',
  component: LAYOUT2,
  meta: {
    title: t('routes.market.home'),
  },
  children: [
    {
      path: '',
      name: 'MarketHome',
      component: () => import('/@/views/home/overview/index.vue'),
      meta: {
        title: t('routes.market.home'),
      },
    },
    {
      path: 'index',
      name: 'Index',
      component: () => import('/@/views/consumption-index/index.vue'),
      meta: {
        title: t('指数'),
      },
    },
    {
      path: 'information',
      name: 'Information',
      component: () => import('/@/views/market/information/index.vue'),
      meta: {
        title: t('资讯公告'),
      },
    },
    // 以下是旧路由，暂时不动
    {
      path: 'packageAssembly',
      name: 'PackageAssembly',
      component: () => import('/@/views/market/packageAssembly/index.vue'),
      meta: {
        // affix: true,
        title: t('maap.portfolio_calculation'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'packageAssemblyDetail/:seqId?/:groupId?',
      name: 'PackageAssemblyDetail',
      component: () => import('/@/views/market/packageAssembly/Detail.vue'),
      meta: {
        // affix: true,
        title: t('maap.portfolio_calculation'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'droDetail/:droCode/:listed?',
      name: 'droDetail',
      component: () => import('/@/views/market/dro/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.mcex.droDetail'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'allMarket',
      name: 'AllMarketPage',
      component: () => import('/@/views/home/overview/AllMarket.vue'),
      meta: {
        // affix: true,
        title: t('maap.marketwide'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },

    {
      path: 'allDro/:brandId?',
      props: true,
      name: 'allDroPage',
      component: () => import('/@/views/market/allDro/index.vue'),
      meta: {
        // affix: true,
        title: t('maap.allDro'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'allBrand',
      name: 'allBrandPage',
      redirect: '/market/allBrand/index',
      meta: {
        // affix: true,
        title: t('maap.allBrand'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
      children: [
        {
          path: 'index',
          name: 'allBrand',
          component: () => import('/@/views/market/allBrand/index.vue'),
          meta: {
            // affix: true,
            title: t('maap.allBrand'),
            hideBreadcrumb: false,
            currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
          },
        },
        {
          path: 'brandDetail/:brandCode',
          name: 'allBrandDetail',
          component: () => import('/@/views/brand/detail/index.vue'),
          meta: {
            // affix: true,
            title: t('品牌详情'),
            hideBreadcrumb: false,
            currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
          },
        },
      ],
    },
    {
      path: 'brandDetail/:brandCode',
      name: 'marketBrandDetail',
      component: () => import('/@/views/brand/detail/index.vue'),
      meta: {
        // affix: true,
        title: t('品牌详情'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
  ],
};

export default market;
